export const Plus = ({ children, ...props }: any) => <svg  width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  {children}
  <rect y="5" width="12" height="2" rx="1" fill="white" />
  <rect x="7" width="12" height="2" rx="1" transform="rotate(90 7 0)" fill="white" />
</svg>
